import React, {Component} from "react";
import {Routes, Route, Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle"
import "./App.css";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthService from "./services/auth.service";
import Login from "./components/login.component";
import Register from "./components/register.component";
import Update from "./components/update.component";
import Profile from "./components/profile.component";
import User from "./components/user.component";
import Payment from "./components/payment.component";
import CreatePayment from "./components/create_payment.component";
import InfoPayment from "./components/info_payment.component";
import InfoPaymentBackup from "./components/info_payment_backup.component";
import InfoPaymentCm from "./components/info_payment_cm.component";
import InfoPaymentCmBackup from "./components/info_payment_cm_backup.component";
import DataManagment from "./components/data_managment.component";
import Confirmation from "./components/confirmation.component";
import Customer from "./components/customer.component";
import PaymentCb from "./components/payment_cb.component";
import ChangePassword from "./components/change_password.component";
import NewPassword from "./components/new_password.component";
import RecoveryRules from "./components/recovery_rules.component";
import RecoveryStage from "./components/recovery_stage.component";
import ParamsService from "./services/params.service";
import logo from './img/logo-ohm-Q.png';
import profil from './img/Profil.png';
import phone from './img/phone.png';
import { BoxArrowRight  } from "react-bootstrap-icons";
import { PersonCircle } from 'react-bootstrap-icons';


import EventBus from "./common/EventBus";
const  cm = ParamsService.$_GET("cm");
const  check = ParamsService.$_GET("check");
const  tokenLink = ParamsService.$_GET("token");
const  from = ParamsService.$_GET("from");

class App extends Component {
    constructor(props) {
        super(props);
        this.logOut = this.logOut.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            currentUser: undefined,
            role : "",
            currentPage: "payments"
        };
    }

    componentDidMount() {
        const user = AuthService.getCurrentUser();
        if(localStorage.getItem('page')){
            this.setState({currentPage: localStorage.getItem('page')});
        }
        if (user) {
            this.setState({currentUser: user, role: user.roles[0]});
        }

        EventBus.on("logout", () => {
            this.logOut();
        });
    }

    componentWillUnmount() {
        EventBus.remove("logout");
    }

    logOut() {
        AuthService.logout();
        this.setState({currentUser: undefined, role:""});
    }

    handleClick(index) {
        localStorage.setItem("page",index.target.dataset.page);
        this.setState({currentPage: index.target.dataset.page});
    };

    render() {
        const {currentUser} = this.state;

        return (
            <div>
                { (from!=="EC" && from!=="AM" && from!=="ALL_PAYMENT") &&
                <nav className="navbar navbar-expand-lg navbar-light bg-light color-light-perso">
                    <Link to={"#"}
                        className="navbar-brand">
                        <img className={"logo"} alt={"logo"}
                            src={logo}/>
                    </Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        {
                            (currentUser && this.state.role!=="ROLE_CUSTOMER") && (

                            <ul className="navbar-nav mr-auto">
                                { (this.state.role ==="ROLE_ADMIN" || this.state.role ==="ROLE_SUPER_AGENT")&&
                                <li className="nav-item">
                                    <Link to={"/agents"}
                                          data-page="agents"
                                          onClick={this.handleClick}
                                          className={this.state.currentPage === "agents" ? "nav-link active" : "nav-link"}>
                                        Gestion des agents
                                    </Link>
                                </li>
                                }
                                {(this.state.role !=="ROLE_CUSTOMER")&&
                                <li className="nav-item">
                                    <Link to={"/payments"}
                                          data-page="payments"
                                          onClick={this.handleClick}
                                          className={this.state.currentPage === "payments" ? "nav-link active" : "nav-link"}>
                                        Gestion des paiements
                                    </Link>
                                </li>
                                }

                                <li className="nav-item">
                                    <Link to={"/create_payment"}
                                          data-page="create_payment"
                                          onClick={this.handleClick}
                                          className={this.state.currentPage === "create_payment" ? "nav-link active" : "nav-link"}>
                                        Créer un paiement
                                    </Link>
                                </li>
                                { (this.state.role ==="ROLE_ADMIN")&&
                                <li className="nav-item">
                                    <Link to={"/data_managment"}
                                          data-page="data_managment"
                                          onClick={this.handleClick}
                                          className={this.state.currentPage === "data_managment" ? "nav-link active" : "nav-link"}>
                                        Gestion des données
                                    </Link>
                                </li>
                                }
                            </ul>
                        )
                    }
                        {
                            (currentUser && this.state.role!=="ROLE_CUSTOMER") && (
                            <div className="navbar-nav ml-auto">
                                <li className="nav-item">
                                    <Link to={"/profile"}
                                        className="nav-link">
                                        <PersonCircle className="person-circle"/> {currentUser.username} </Link>
                                </li>
                                <li className="nav-item">
                                    <a href="/login" className="nav-link"
                                        onClick={
                                            this.logOut
                                    }>
                                        Déconnexion <BoxArrowRight className="arrow-right"/>

                                    </a>
                                </li>
                            </div>
                        )
                    }
                        {
                            ((currentUser && this.state.role==="ROLE_CUSTOMER") || cm || tokenLink) &&(from!=="ALL_PAYMENT") && (
                                <>
                                    { !check &&(
                                            <div  className="msg-customer">
                                                <label>Vous êtes invité(e) à régulariser vos dettes.</label>
                                            </div>
                                        )
                                    }
                                    <div className="navbar-nav ml-auto nav-customer">
                                        <li className="nav-item ">
                                            <a  href="tel:+33970702125" className="nav-link btn-customer customer-phone">
                                                <img alt="tel ohm Energie" className='img-customer' src={phone}/>
                                                <b>  09 70 70 21 25</b>
                                            </a>
                                        </li>

                                        <li className="nav-item">
                                            <a  href={"https://espace-client.ohm-energie.com/login"} rel="noreferrer" target={"_blank"} className="nav-link btn-customer customer-profil">
                                                <img alt="Espace client" className='img-customer' src={profil}/>
                                                <b> Espace client</b>
                                            </a>
                                        </li>

                                    </div>
                                </>
                            )
                        }
                    </div>
                </nav>
                }

                <div className="container mt-3">
                    <Routes>
                        <Route path="/"
                            element={<Login/>}/>
                        <Route path="/login"
                            element={<Login/>}/>
                        <Route path="/register"
                            element={<Register/>}/>
                        <Route path="/update"
                            element={<Update/>}/>
                        <Route path="/profile"
                            element={<Profile/>}/>
                        <Route path="/agents"
                            element={<User/>}/>
                        <Route path="/payments"
                            element={<Payment/>}/>
                        <Route path="/create_payment"
                            element={<CreatePayment/>}/>
                        <Route path="/info_payment"
                            element={<InfoPayment/>}/>
                        <Route path="/info_payment_backup"
                               element={<InfoPaymentBackup/>}/>
                        <Route path="/info_payment_cm/:cm"
                               element={<InfoPaymentCm/>}/>
                        <Route path="/info_payment_cm_backup/:cm"
                               element={<InfoPaymentCmBackup/>}/>
                        <Route path="/data_managment"
                           element={<DataManagment/>}/>
                        <Route path="/confirmation/:cm"
                               element={<Confirmation/>}/>
                        <Route path="/payment/:token"
                               element={<Customer/>}/>
                        <Route path="/payment_cb/:token"
                               element={<PaymentCb/>}/>
                        <Route path="/change/password"
                               element={<ChangePassword/>}/>
                        <Route path="/new/password/:id"
                               element={<NewPassword/>}/>
                        <Route path="/recovery_rules"
                               element={<RecoveryRules/>}/>
                        <Route path="/recovery_stage"
                               element={<RecoveryStage/>}/>
                </Routes>
                </div>

                {/* <AuthVerify logOut={this.logOut}/> */}
                <ToastContainer/>

            </div>

        );
    }
}

export default App;

